import React from 'react';

function About() {
  return (
    <section>
      <h2>About Me</h2>
      <p>
        I am a Senior Web Developer with expertise in full-stack development, focusing on delivering
        innovative solutions that meet client needs. I have a strong background in project management, and a passion for learning new technologies.
      </p>
    </section>
  );
}

export default About;
